/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "ยกเลิก"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "คุณมีเหตุผลทางธุรกิจในการเข้าถึงข้อมูลของลูกค้า"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "กิจกรรมการดาวน์โหลดของคุณจะได้รับการบันทึกและติดตามเพื่อวัตถุประสงค์ในการปฏิบัติตามข้อกำหนดด้านความปลอดภัย"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "คุณต้องการดำเนินการต่อหรือไม่"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "เมื่อดาวน์โหลด คุณยอมรับว่า"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
